"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Practice_exports = {};
__export(Practice_exports, {
  default: () => Practice_default
});
module.exports = __toCommonJS(Practice_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.9531 7.75C15.1354 7.75 15.3047 7.78255 15.4609 7.84766C15.6302 7.89974 15.7799 7.97786 15.9102 8.08203L15.9883 8.16016L17.668 9.87891C17.8763 10.0872 17.987 10.3346 18 10.6211C18.013 10.8945 17.9284 11.1419 17.7461 11.3633L17.668 11.4414L15.9883 13.1602C15.8711 13.2773 15.7344 13.375 15.5781 13.4531C15.4219 13.5182 15.2591 13.5573 15.0898 13.5703L14.9531 13.5898H4.36719C4.01562 13.5898 3.70964 13.4857 3.44922 13.2773C3.1888 13.056 3.03906 12.7956 3 12.4961V12.3789V8.94141C3 8.62891 3.11719 8.36198 3.35156 8.14062C3.59896 7.90625 3.89844 7.77604 4.25 7.75H4.36719H14.9531ZM5.87109 8.78516H4.36719C4.32812 8.78516 4.28906 8.79818 4.25 8.82422C4.21094 8.83724 4.1849 8.86328 4.17188 8.90234V8.94141V12.3789C4.17188 12.418 4.1849 12.457 4.21094 12.4961C4.23698 12.5221 4.26953 12.5417 4.30859 12.5547H4.36719H5.87109V8.78516ZM12.6094 12.0273H6.71094V12.5547H12.8438L12.668 12.2227L12.6289 12.125L12.6094 12.0273ZM14.9531 8.78516H13.7812L13.3711 9.76172L13.7422 10.1523C13.8724 10.2695 13.9505 10.4128 13.9766 10.582C14.0026 10.7383 13.9766 10.8945 13.8984 11.0508L13.8594 11.1289L13.3711 11.8711L13.7227 12.5547H14.9531C14.9792 12.5547 14.9987 12.5547 15.0117 12.5547C15.0247 12.5417 15.0443 12.5352 15.0703 12.5352L15.1094 12.4961L15.9102 11.6758V9.66406L15.1094 8.84375C15.0964 8.83073 15.0768 8.81771 15.0508 8.80469C15.0378 8.79167 15.0247 8.78516 15.0117 8.78516H14.9531ZM12.6875 10.1523H6.71094V11.207H12.8633L13.1953 10.6992L12.8242 10.3281C12.7982 10.3021 12.7721 10.276 12.7461 10.25C12.7331 10.224 12.7135 10.1914 12.6875 10.1523ZM12.9219 8.78516H6.71094V9.33203H12.707L12.9219 8.78516Z",
      fill: "currentColor"
    }
  )
);
const SvgPractice = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Practice_default = SvgPractice;
